// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-post-detail-style__wrapper_Ac5ZJ"};